import {
    ScrollShift,
    actColLeft,
    actColRight,
    itemMotion,
} from "@/components/ScrollMotion";

const images = [
    {
        cls: "md:col-span-7 aspect-[4/3]",
        cap: "01",
        locked: true,
    },
    {
        cls: "md:col-span-5 aspect-[3/4]",
        cap: "02",
        locked: true,
    },
    {
        cls: "md:col-span-4 aspect-[3/4]",
        cap: "03",
        locked: true,
    },
    {
        cls: "md:col-span-8 aspect-[16/10]",
        cap: "04",
        locked: true,
    },
    {
        src: "https://static.prod-images.emergentagent.com/jobs/f06a9f9c-d82b-43ef-be36-a164b4102429/images/c85528aed0ed1ecd8e474f7d2c577626a733b433833ad493a9650699bf0326e8.png",
        cls: "md:col-span-12 aspect-[21/9]",
        cap: "Zamek Moszna",
        locked: false,
    },
];

export default function Gallery() {
    return (
        <section
            id="galeria"
            data-testid="gallery-section"
            className="section-pad relative overflow-hidden bg-ink"
        >
            <div className="container-luxe">
                <div className="mb-16 flex flex-col justify-between gap-8 md:mb-24 md:flex-row md:items-end">
                    <ScrollShift {...actColLeft} className="max-w-xl">
                        <span className="overline text-[14px] md:text-[17px]">
                            Akt VI — Galeria
                        </span>

                        <h2 className="mt-6 font-serif italic text-5xl text-ivory md:text-6xl lg:text-7xl">
                            Kadry
                            <br />
                            <span className="text-champagne not-italic">
                                przed dniem
                            </span>
                        </h2>
                    </ScrollShift>

                    <ScrollShift
                        {...actColRight}
                        className="max-w-sm md:pb-2"
                    >
                        <p className="text-sm text-ivory/55 md:text-base">
                            Sesja narzeczeńska — fragmenty czasu, które
                            pozwoliliśmy sobie zatrzymać. Kolejne kadry będą
                            pojawiały się tutaj stopniowo po 19 lipca.
                        </p>
                    </ScrollShift>
                </div>

                <div className="grid grid-cols-1 gap-3 md:grid-cols-12 md:gap-5">
                    {images.map((img, i) => (
                        <ScrollShift
                            key={img.cap}
                            {...itemMotion(i)}
                            className={`group relative overflow-hidden border border-champagne/25 ${img.cls}`}
                        >
                            {img.locked ? (
                                <div className="flex h-full w-full items-center justify-center bg-ivory/[0.03]">
                                    <div className="text-center">
                                        <div className="mx-auto mb-6 flex h-10 w-10 items-center justify-center rounded-full border border-champagne/35 text-champagne/70">
                                            ✦
                                        </div>

                                        <span className="overline block text-ivory/45">
                                            Kadr pojawi się
                                        </span>

                                        <span className="overline mt-2 block text-ivory/45">
                                            niebawem
                                        </span>
                                    </div>

                                    <span className="absolute bottom-5 right-5 font-serif text-xl text-champagne/70">
                                        {img.cap}
                                    </span>
                                </div>
                            ) : (
                                <>
                                    <img
                                        src={img.src}
                                        alt={img.cap}
                                        className="h-full w-full object-cover transition-transform duration-[1800ms] ease-out group-hover:scale-105"
                                    />

                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 transition-opacity duration-700 group-hover:opacity-100" />

                                    <div className="absolute bottom-5 left-5 translate-y-2 opacity-100 transition-all duration-700 group-hover:translate-y-0">
                                        <span className="font-serif text-2xl text-ivory md:text-3xl">
                                            {img.cap}
                                        </span>
                                    </div>

                                    <span className="absolute bottom-5 right-5 font-serif text-xl text-champagne/80">
                                        05
                                    </span>
                                </>
                            )}
                        </ScrollShift>
                    ))}
                </div>
            </div>
        </section>
    );
}